import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { images } from '../../../utils/icons';

const styles = {
  resolved: {
    width: '1rem',
    height: '1rem',
    position: 'absolute',
    right: '-3px',
    top: '-3px',
  },
};

const Completed = ({ classes, children, completed }) => {
  return (
    <>
      {children}
      {completed && (
        <img className={classes.resolved} alt="" src={images.success} />
      )}
    </>
  );
};

Completed.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.object,
  completed: PropTypes.bool,
};

export default withStyles(styles)(Completed);
